"use client";

import { useState } from "react";
import LoginForm from "./components/LoginForm";
import RegisterForm from "./components/RegisterForm";
import ForgotForm from "./components/ForgotForm";

export default function AuthForm({ onSuccess }) {
  const [activeTab, setActiveTab] = useState("login");

  return (
    <section className="relative pb-10 md:pb-20 flex items-center">
      <div className="container mx-auto px-4">
        <div className="flex justify-center">
          <div className="w-full max-w-2xl">
            <div className="bg-white rounded-3xl shadow-2xl p-5 md:p-10">

              {/* -------- TABS (Hide in Forgot) -------- */}
              {activeTab !== "forgot" && (
                <div className="flex justify-center mb-8 border-b">
                  <button
                    onClick={() => setActiveTab("login")}
                    className={`px-8 py-3 font-semibold ${
                      activeTab === "login"
                        ? "text-[#162e40] border-b-4 border-[#162e40]"
                        : "text-gray-500"
                    }`}
                  >
                    Login
                  </button>

                  <button
                    onClick={() => setActiveTab("register")}
                    className={`px-8 py-3 font-semibold ${
                      activeTab === "register"
                        ? "text-[#162e40] border-b-4 border-[#162e40]"
                        : "text-gray-500"
                    }`}
                  >
                    Register
                  </button>
                </div>
              )}

              {/* -------- PAGES -------- */}
              {activeTab === "login" && (
                <LoginForm
                  switchTab={(val) => setActiveTab(val)}
                  onSuccess={onSuccess}
                />
              )}

              {activeTab === "register" && (
                <RegisterForm
                  switchTab={() => setActiveTab("login")}
                  onSuccess={onSuccess}
                />
              )}

              {activeTab === "forgot" && (
                <ForgotForm switchTab={(val) => setActiveTab(val)} />
              )}

            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
